<template>
    <transition name="modal">
        <div class="search-mask">
            <div class="search-wrapper">
                <div class="search-container">

                    <div class="search-header">
                        <slot name="header">
                            <h4>Advanced Search</h4>
                        </slot>
                    </div>

                    <div class="search-body">
                        <slot name="body">
                            <tabs ref="tabs" v-on:tab-changed="onTabChange">

                                <tab name="Explicit Region" :selected="preSelectedTab('Explicit Region')">
                                    <div class="layer">
                                        <div class="inner">
                                            <div class="mod">
                                                <div class="bd text-block">
                                                    Enter a region name (County, State, or Zip) and an Address, Owner Name or Parcel ID
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="layer">
                                        <div class="inner">
                                            <div class="mod">
                                                <form id="explicit_region" @submit.prevent>
                                                    <explicit-region :owner-address-parcel-error="ownerAddressParcelError"
                                                                     :region-error="regionError"
                                                                     :owner-address-parcel.sync="explicitOwnerAddressParcelC"
                                                                     :selected-owner-address-parcel.sync="explicitOwnerAddressParcelSelectedC"
                                                                     :region.sync="explicitRegionStringC"
                                                                     ref="explicitRegion"
                                                                     key="advancedSearch"
                                                    ></explicit-region>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </tab>

                                <tab name="Advanced" :selected="preSelectedTab('Advanced')">
                                    <div class="layer">
                                        <div class="inner">
                                            <div class="mod">
                                                <form id="advanced_search" @submit.prevent>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Region</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="2of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li ref="advancedRegionField" class="field-show-label">
                                                                        <label :for="'advanced_region'">County, State, or Zip</label>
                                                                        <autocomplete
                                                                            form-id="advanced_region"
                                                                            data-source="/json/online-region-autocomplete"
                                                                            name="advanced_region"
                                                                            :threshold="3"
                                                                            sub-value="region_name"
                                                                            ref="advancedRegion"
                                                                            :input-string="advancedSearchValuesC.region"
                                                                            @update:inputString="$set(advancedSearchValuesC, 'region', $event)"
                                                                            v-on:selected="onAdvancedRegionAutocompleteSelect"
                                                                            v-on:input="onAdvancedRegionInputChange"
                                                                            :key="advancedRegionAutocompleteKey">
                                                                            <template v-slot:suggestionTemplate="item">
                                                                                <table>
                                                                                    <tr>
                                                                                        <td v-bind:style="{ color: (item.item.num_parcels === 0) ? 'gray' : null }">
                                                                                            <span style="font-weight: bold" v-bind:style="{ color: (item.item.num_parcels > 0) ? 'blue' : 'gray' }">
                                                                                                {{ item.item.region_name }}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td style="padding-left: 15px" v-bind:style="{ color: (item.item.num_parcels > 0) ? 'green' : 'gray'}">
                                                                                            {{ item.item.region_type }}
                                                                                        </td>
                                                                                        <td style="padding-left: 4px">
                                                                                            <span v-if="item.item.num_parcels > 0" style="color: darkgreen; font-weight: bold"
                                                                                                  :title="'Have data (' + item.item.num_parcels + ' parcels)'">
                                                                                                √
                                                                                            </span>
                                                                                            <span v-else style="color: gray" title="No data">×</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </template>
                                                                        </autocomplete>
                                                                        <div v-if="advancedRegionError" class="validation-message">
                                                                            Region is required
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Transfer Date</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="trans_date_min">Min</label>
                                                                        <input class="advanced-input"
                                                                               type="date"
                                                                               name="trans_date_min"
                                                                               id="trans_date_min"
                                                                               :value="advancedSearchValuesC.trans_date_min"
                                                                               @input="$set(advancedSearchValuesC, 'trans_date_min', $event.target.value)"
                                                                               placeholder="blank = old">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="trans_date_max">Max</label>
                                                                        <input class="advanced-input"
                                                                               type="date"
                                                                               name="trans_date_max"
                                                                               id="trans_date_max"
                                                                               :value="advancedSearchValuesC.trans_date_max"
                                                                               @input="$set(advancedSearchValuesC, 'trans_date_max', $event.target.value)"
                                                                               placeholder="blank = today">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Sale Price</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="sale_price_min">Min</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="sale_price_min"
                                                                               id="sale_price_min"
                                                                               :value="advancedSearchValuesC.sale_price_min"
                                                                               @input="$set(advancedSearchValuesC, 'sale_price_min', $event.target.value)"
                                                                               placeholder="blank = –∞">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="sale_price_max">Max</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="sale_price_max"
                                                                               id="sale_price_max"
                                                                               :value="advancedSearchValuesC.sale_price_max"
                                                                               @input="$set(advancedSearchValuesC, 'sale_price_max', $event.target.value)"
                                                                               placeholder="blank = ∞">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Building Square Feet</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="bldg_sqft_min">Min</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="bldg_sqft_min"
                                                                               id="bldg_sqft_min"
                                                                               :value="advancedSearchValuesC.bldg_sqft_min"
                                                                               @input="$set(advancedSearchValuesC, 'bldg_sqft_min', $event.target.value)"
                                                                               placeholder="blank = 0">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="bldg_sqft_max">Max</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="bldg_sqft_max"
                                                                               id="bldg_sqft_max"
                                                                               :value="advancedSearchValuesC.bldg_sqft_max"
                                                                               @input="$set(advancedSearchValuesC, 'bldg_sqft_max', $event.target.value)"
                                                                               placeholder="blank = ∞">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Number of Stories</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="story_height_min">Min</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="story_height_min"
                                                                               id="story_height_min"
                                                                               :value="advancedSearchValuesC.story_height_min"
                                                                               @input="$set(advancedSearchValuesC, 'story_height_min', $event.target.value)"
                                                                               placeholder="blank = 0">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="story_height_max">Max</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="story_height_max"
                                                                               id="story_height_max"
                                                                               :value="advancedSearchValuesC.story_height_max"
                                                                               @input="$set(advancedSearchValuesC, 'story_height_max', $event.target.value)"
                                                                               placeholder="blank = ∞">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Neighborhood Code</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li>
                                                                        <label for="ngh_code">Code</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="ngh_code"
                                                                               :value="advancedSearchValuesC.ngh_code"
                                                                               @input="$set(advancedSearchValuesC, 'ngh_code', $event.target.value)"
                                                                               id="ngh_code">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Land Use Class</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="2of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li>
                                                                        <label for="land_use_class">Class</label>
                                                                        <div class="select-wrapper">
                                                                            <select class="advanced-input"
                                                                                    name="land_use_class"
                                                                                    id="land_use_class"
                                                                                    type="text"
                                                                                    v-model="landUseClassSelection"
                                                                                    multiple>
                                                                                <option selected></option>
                                                                                <option value="Residential">Residential</option>
                                                                                <option value="Agricultural">Agricultural</option>
                                                                                <option value="Commercial">Commercial</option>
                                                                                <option value="Industrial">Industrial</option>
                                                                                <option value="Mineral">Mineral</option>
                                                                                <option value="Tax Exempt">Tax Exempt</option>
                                                                            </select>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Deeded Acreage</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="acreage_min">Min</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="acreage_min"
                                                                               id="acreage_min"
                                                                               :value="advancedSearchValuesC.acreage_min"
                                                                               @input="$set(advancedSearchValuesC, 'acreage_min', $event.target.value)"
                                                                               placeholder="blank = 0">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="acreage_max">Max</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="acreage_max"
                                                                               id="acreage_max"
                                                                               :value="advancedSearchValuesC.acreage_max"
                                                                               @input="$set(advancedSearchValuesC, 'acreage_max', $event.target.value)"
                                                                               placeholder="blank = ∞">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">Calculated Acreage</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="calc_acreage_min">Min</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="calc_acreage_min"
                                                                               id="calc_acreage_min"
                                                                               :value="advancedSearchValuesC.calc_acreage_min"
                                                                               @input="$set(advancedSearchValuesC, 'calc_acreage_min', $event.target.value)"
                                                                               placeholder="blank = 0">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li class="field-show-label">
                                                                        <label for="calc_acreage_max">Max</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="calc_acreage_max"
                                                                               id="calc_acreage_max"
                                                                               :value="advancedSearchValuesC.calc_acreage_max"
                                                                               @input="$set(advancedSearchValuesC, 'calc_acreage_max', $event.target.value)"
                                                                               placeholder="blank = ∞">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col" style-size="1of4">
                                                            <div class="mod">
                                                                <h4 class="h4">School District ID</h4>
                                                            </div>
                                                        </div>
                                                        <div class="col" style-size="1of3">
                                                            <div class="mod">
                                                                <ul class="form-fields list-spaced">
                                                                    <li>
                                                                        <label for="school_dist_id">District ID</label>
                                                                        <input class="advanced-input"
                                                                               type="text"
                                                                               name="school_dist_id"
                                                                               :value="advancedSearchValuesC.school_dist_id"
                                                                               @input="$set(advancedSearchValuesC, 'school_dist_id', $event.target.value)"
                                                                               id="school_dist_id">
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </tab>

                                <tab name="Text Search" :selected="preSelectedTab('Text Search')">
                                    <div class="layer">
                                        <div class="inner">
                                            <div class="mod">
                                                <div class="bd text-block">
                                                    <form id="text_query" @submit.prevent class="basic-search-details">
                                                        <basic-search v-on:basic-search-submitted="basicSearch"
                                                                      :text-search.sync="textQueryC">
                                                        </basic-search>
                                                        <div style="margin-top: 16px; margin-left: 5px;">
                                                            <p>By address: 4603 Brookpark Rd, Cleveland, OH</p>
                                                            <p>By owner: Smith J in Parma, OH</p>
                                                            <p>By APN: 25-051800 Geauga, OH</p>
                                                            <p>By lon, lat: 41.412406, -81.715064</p>
                                                            <p>Separate multiple with semicolons: 4927 brookpark rd, cleveland, oh; 4603 brookpark, 44134</p>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>

                                <tab name="Shapefile" :selected="preSelectedTab('Shapefile')">
                                    <div class="layer">
                                        <div class="inner">
                                            <div class="mod">
                                                <div class="bd text-block">
                                                    Upload an ESRI shapefile to find parcels that intersect with it:<br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <form id="shapefile" @submit.prevent>
                                    <div class="layer">
                                        <div class="inner">
                                            <div class="mod">
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="mod">
                                                            <h4 class="h4">.shp</h4>
                                                        </div>
                                                    </div>
                                                    <div class="col" style-size="1of4">
                                                        <div class="mod">
                                                            <ul class="form-fields list-spaced">
                                                                <li ref="shpFileField">
                                                                    <label for="shapefile_shp">Shp</label>
                                                                    <input ref="shp" type="file" name="shapefile_shp" id="shapefile_shp">
                                                                    <div v-if="shpError" class="validation-message">
                                                                        .shp file is required
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="mod">
                                                            <h4 class="h4">.shx</h4>
                                                        </div>
                                                    </div>
                                                    <div class="col" style-size="1of4">
                                                        <div class="mod">
                                                            <ul class="form-fields list-spaced">
                                                                <li ref="shxFileField">
                                                                    <label for="shapefile_shx">Shx</label>
                                                                    <input ref="shx" type="file" name="shapefile_shx" id="shapefile_shx">
                                                                    <div v-if="shxError" class="validation-message">
                                                                        .shx file is required
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="mod">
                                                            <h4 class="h4">.dbf</h4>
                                                        </div>
                                                    </div>
                                                    <div class="col" style-size="1of4">
                                                        <div class="mod">
                                                            <ul class="form-fields list-spaced">
                                                                <li ref="dbfFileField">
                                                                    <label for="shapefile_dbf">Dbf</label>
                                                                    <input ref="dbf" type="file" name="shapefile_dbf" id="shapefile_dbf">
                                                                    <div v-if="dbfError" class="validation-message">
                                                                        .dbf file is required
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="mod">
                                                            <h4 class="h4">.prj</h4>
                                                        </div>
                                                    </div>
                                                    <div class="col" style-size="1of4">
                                                        <div class="mod">
                                                            <ul class="form-fields list-spaced">
                                                                <li ref="prjFileField">
                                                                    <label for="shapefile_shp">Prj</label>
                                                                    <input ref="prj" type="file" name="shapefile_prj" id="shapefile_prj">
                                                                    <div v-if="prjError" class="validation-message">
                                                                        .prj file is required
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col" style-size="1of4">
                                            <div class="mod">
                                                <h4 class="h4">Calculated Acreage</h4>
                                            </div>
                                        </div>
                                        <div class="col" style-size="1of3">
                                            <div class="mod">
                                                <ul class="form-fields list-spaced">
                                                    <li class="field-show-label">
                                                        <label for="shp_calc_acreage_min">Min</label>
                                                        <input class="advanced-input" type="text" name="calc_acreage_min" id="shp_calc_acreage_min" placeholder="blank = 0">
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col" style-size="1of3">
                                            <div class="mod">
                                                <ul class="form-fields list-spaced">
                                                    <li class="field-show-label">
                                                        <label for="shp_calc_acreage_max">Max</label>
                                                        <input class="advanced-input" type="text" name="calc_acreage_max" id="shp_calc_acreage_max" placeholder="blank = ∞">
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col" style-size="2of4">
                                            <div class="mod">
                                                <h4 class="h4">Minimum acreage of intersection with uploaded shapefile</h4>
                                            </div>
                                        </div>
                                        <div class="col" style-size="1of3">
                                            <div class="mod">
                                                <ul class="form-fields list-spaced">
                                                    <li>
                                                        <label for="min_intersection">Minimum</label>
                                                        <input class="advanced-input" type="text" name="shpintersect_calc_acreage_min" id="min_intersection" placeholder="blank = 0">
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col" style-size="1of4">
                                            <div class="mod">
                                                <h4 class="h4">Improvement (building) value</h4>
                                            </div>
                                        </div>
                                        <div class="col" style-size="1of3">
                                            <div class="mod">
                                                <ul class="form-fields list-spaced">
                                                    <li class="field-show-label">
                                                        <label for="min_improvement_value">Min</label>
                                                        <input class="advanced-input" type="text" name="mkt_val_bldg_min" id="min_improvement_value" placeholder="blank = 0">
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col" style-size="1of3">
                                            <div class="mod">
                                                <ul class="form-fields list-spaced">
                                                    <li class="field-show-label">
                                                        <label for="max_improvement_value">Max</label>
                                                        <input class="advanced-input" type="text" name="mkt_val_bldg_max" id="max_improvement_value" placeholder="blank = ∞">
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="layer">
                                        <div class="inner">
                                            <div class="mod">
                                                <div class="bd text-block">
                                                    <span style="font-size: smaller">
                                                        Please Note: Maximum uploaded file size is 64MB. Other limits apply which will be checked before the search is performed.<br>
                                                        Contact <a href="mailto:support@reportallusa.com">support@reportallusa.com</a> if you have larger needs.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </form>
                                </tab>
                            </tabs>
                        </slot>
                    </div>

                    <div class="search-footer">
                        <slot name="footer">
                            <button class="button" style-color="grey" @click="$emit('close')">
                                Cancel
                            </button>
                            <button class="button" @click="search">
                                Search
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import BasicSearch from "./BasicSearch";
    export default {
        name: "AdvancedSearch",
        components: {BasicSearch},
        data () {
            return {
                regionError: false,
                ownerAddressParcelError: false,
                advancedRegionError: false,
                shpError: false,
                shxError: false,
                dbfError: false,
                prjError: false,
                advancedRegionAutocompleteKey: _.uniqueId('autocomplete-key'),
                inputFiltered: false,
                advancedSearchParams: {
                    trans_date: '#trans_date_min,#trans_date_max',
                    sale_price: '#sale_price_min,#sale_price_max',
                    bldg_sqft: '#bldg_sqft_min,#bldg_sqft_max',
                    story_height: '#story_height_min,#story_height_max',
                    ngh_code: '#ngh_code',
                    land_use_class: '#land_use_class',
                    acreage: '#acreage_min,#acreage_max',
                    calc_acreage: '#calc_acreage_min,#calc_acreage_max',
                    school_dist_id: '#school_dist_id'
                },
                advancedRegionString: '',
            }
        },

        props: {
            explicitRegionString: String,
            explicitOwnerAddressParcelSelected: String,
            explicitOwnerAddressParcel: String,
            textQuery: String,
            selectedTab: {
                type: String,
                default: 'Explicit Region'
            },
            advancedSearchValues: Object
        },

        computed: {
            explicitRegionStringC: {
                get() { return this.explicitRegionString },
                set(value) { this.$emit('update:explicitRegionString', value) }
            },
            explicitOwnerAddressParcelSelectedC: {
                get() { return this.explicitOwnerAddressParcelSelected },
                set(value) { this.$emit('update:explicitOwnerAddressParcelSelected', value) }
            },
            explicitOwnerAddressParcelC: {
                get() { return this.explicitOwnerAddressParcel },
                set(value) { this.$emit('update:explicitOwnerAddressParcel', value) }
            },
            textQueryC: {
                get() { return this.textQuery },
                set(value) { this.$emit('update:textQuery', value); }
            },
            advancedSearchValuesC: {
                get() { return this.advancedSearchValues },
                set(value) { this.$emit('update:advancedSearchValues', value); }
            },
            landUseClassSelection: {
                get() { return this.advancedSearchValuesC.land_use_class },
                set(value) { this.$set(this.advancedSearchValuesC, 'land_use_class', value); }
            }
        },

        methods: {
            basicSearch: function(search) {
                this.$emit('basic-search-submitted', search);
            },

            onAdvancedRegionAutocompleteSelect: function (region) {
                let availableAttributes = region.parcel_attrs;
                for (let attributeName in this.advancedSearchParams) {
                    if(availableAttributes.indexOf(attributeName) === -1) {
                        $(this.advancedSearchParams[attributeName]).prop('disabled', true);
                    }
                }
                this.inputFiltered = true;
            },

            onAdvancedRegionInputChange: function () {
                if (this.inputFiltered)
                    $('.advanced-input').prop('disabled', false);
            },

            search: function() {
                const activeTab = this.$refs.tabs.activeTab;
                let formData = null;

                if (activeTab.name === "Explicit Region") {
                    this.regionError = false;
                    this.ownerAddressParcelError = false;
                    this.$refs.explicitRegion.$refs.regionField.classList.remove('validation', 'validation-error');
                    this.$refs.explicitRegion.$refs.ownerAddressParcelField.classList.remove('validation', 'validation-error');
                    if (
                        this.explicitRegionString === ''
                        || this.explicitRegionString.trim() === ''
                    ) {
                        this.regionError = true;
                        this.$refs.explicitRegion.$refs.region.$refs.autocompleteInput.focus();
                        this.$refs.explicitRegion.$refs.regionField.classList.add('validation', 'validation-error');
                        return;
                    }
                    if (
                        this.explicitOwnerAddressParcel === ''
                        || this.explicitOwnerAddressParcel.trim() === ''
                    ) {
                        this.ownerAddressParcelError = true;
                        this.$refs.explicitRegion.$refs.ownerAddressParcel.$refs.autocompleteInput.focus();
                        this.$refs.explicitRegion.$refs.ownerAddressParcelField.classList.add('validation', 'validation-error');
                        return;
                    }
                    formData = $('#explicit_region').serialize();
                    this.$emit('explicit-region', formData);
                } else if (activeTab.name === "Advanced") {
                    this.advancedRegionError = false;
                    this.$refs.advancedRegionField.classList.remove('validation', 'validation-error');
                    if (
                        !this.advancedSearchValuesC.region
                        || (this.advancedSearchValuesC.region && this.advancedSearchValuesC.region.trim() === '')
                    ) {
                        this.advancedRegionError = true;
                        this.$refs.advancedRegion.$refs.autocompleteInput.focus();
                        this.$refs.advancedRegionField.classList.add('validation', 'validation-error');
                        return;
                    }
                    formData = $('#advanced_search').serialize();
                    this.$emit('advanced-search', formData);
                } else if (activeTab.name === "Shapefile") {
                    this.shpError = false;
                    this.shxError = false;
                    this.prjError = false;
                    this.dbfError = false;
                    this.$refs.shpFileField.classList.remove('validation', 'validation-error');
                    this.$refs.shxFileField.classList.remove('validation', 'validation-error');
                    this.$refs.prjFileField.classList.remove('validation', 'validation-error');
                    this.$refs.dbfFileField.classList.remove('validation', 'validation-error');
                    if (this.$refs.shp.files.length === 0) {
                        this.shpError = true;
                        this.$refs.shpFileField.classList.add('validation', 'validation-error');
                        return;
                    }
                    if (this.$refs.shx.files.length === 0) {
                        this.shxError = true;
                        this.$refs.shxFileField.classList.add('validation', 'validation-error');
                        return;
                    }
                    if (this.$refs.prj.files.length === 0) {
                        this.prjError = true;
                        this.$refs.prjFileField.classList.add('validation', 'validation-error');
                        return;
                    }
                    if (this.$refs.dbf.files.length === 0) {
                        this.dbfError = true;
                        this.$refs.dbfFileField.classList.add('validation', 'validation-error');
                        return;
                    }
                    formData = new FormData(document.querySelector('#shapefile'));
                    this.$emit('shapefile-search', formData);
                } else if (activeTab.name === 'Text Search') {
                    formData = $('#text_query').serialize();
                    this.$emit('basic-search', formData);
                } else {
                    return;
                }

                this.$emit('close');
            },

            onTabChange: function (selectedTab) {
                this.$emit('update:selectedTab', selectedTab);
                if (selectedTab === 'Advanced') {
                    this.$refs.advancedRegion.reflowAutocomplete();
                }
            },

            preSelectedTab: function (tabName) {
                return tabName === this.selectedTab;
            },
        }
    }
</script>

<style scoped>
    .search-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .search-wrapper {
        vertical-align: middle;
        position: relative;
        top: 100px;
    }

    .search-container {
        width: 60%;
        max-height: calc(100vh - 200px);
        overflow-y: auto;
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }

    .search-header h4 {
        margin-top: 0;
        color: #42b983;
    }

    .search-body {
        margin: 40px 0;
        max-height: calc(100vh - 350px);
    }

    /deep/ .tabs-details {
        max-height: calc(100vh - 400px);
        overflow: auto;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .basic-search-details p {
        font-size: 10pt;
    }

    .modal-enter .search-container,
    .modal-leave-active .search-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
